// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
export enum OrderType {
  standard = 1,
  demo = 2,
};
export const ORDER_MAX_COUNT = 100000;  // maximum number of orders
export const ORDER_TYPES_LABELS = {
  [OrderType.standard]: 'Standard',
  [OrderType.demo]: 'Demo',
};

export enum OrderStatus {
  deactivated = 1,
  inProgress = 2,
  pending = 3,
  completed = 4,
  completedWithFailures = 5
}

export const ORDER_STATUSES_LABELS = {
  [OrderStatus.deactivated]: 'Deactivated',
  [OrderStatus.completed]: 'Complete',
  [OrderStatus.completedWithFailures]: 'Complete with failures',
  [OrderStatus.pending]: 'Pending',
  [OrderStatus.inProgress]: 'In progress',
};

export const ORDER_FIELDS = {
  orderName: 'orderName',
  orderNumber: 'orderNumber',
  type: 'type',
  orderTasks: 'deliverables',
  customerId: 'customerId',
  customerName: 'customerName',
  dueDate: 'dueDate',
  expectedDueDate: 'expectedDueDate',
  actualDueDate: 'actualDueDate',
  notes: 'notes',
  status: 'status',
  id: 'id',
  isBlocked: 'isBlocked',
  isActive: 'isActive'
};
